import { action, makeAutoObservable, toJS } from "mobx";
import _ from "lodash";
import { ReportTransformers } from "../report-visuals/report-transformers";
import { safe_get } from "../report-visuals/report-utils";
import { withAudioFlag } from "../features/survey-management/survey-summary/row-has-audio";
import { hydrateAudioFlags, mergeAudioDetail } from "../features/survey-management/survey-summary/hydrate-audio-flags";
import { fillNullSummary } from "../new-features/field-team-report-v2/fill-null-summary";
import { noAudioClientIds } from "../features/survey-management/survey-summary/no-audio-client-ids";

export class SurveyResponseStore {
    hasCheckedAuth: boolean = false;
    user: any = null;
    isAuthorized: boolean = false;

    regions: any = [];
    activeSurveyId: any = null;
    activeSurveyResponseId: any = null;
    reportPayload: any = null;
    allSurveyResponses: any;
    allSurveyResponsesSummary: any;
    analytical_meta: any;
    analytical_data: any;
    surveyResponseFilters: any;
    tags: any;
    activeSurveyResponse: any;
    colors: any;
    drill_filters: any;
    currentPageTracker: any;
    survey_list_api: any;
    loading: boolean;
    query: any;
    searchHighlights: boolean;
    allTags: any;
    currentReportPayload: any = null;

    activeQuestion: any = {};

    new_filters: any;

    showTableSettingsModal: boolean = false;
    reportVersion: number = 3;
    audioRecheckLoading: boolean = false;
    rootStore: any;

    constructor(rootStore: any) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
        this.isAuthorized = false;
        this.hasCheckedAuth = false;
        this.currentPageTracker = 0;
        this.regions = [];
        this.activeSurveyId = -1;
        this.activeSurveyResponseId = null;

        this.allSurveyResponses = [];
        this.noAudioSampleIds = [];

        this.allSurveyResponsesSummary = {};
        this.analytical_meta = [];
        this.drill_filters = [];
        this.analytical_data = {};
        this.surveyResponseFilters = {};
        this.tags = [];
        this.activeSurveyResponse = {};
        console.log("Stored Active Survey", this.activeSurveyResponse);
        console.log("Stored SR", this.activeSurveyResponse?.sr);
        console.log("Stored S3", this.activeSurveyResponse?.s3uri);
        this.colors = [];
        this.query = "";
        this.searchHighlights = false;
        this.new_filters = [];
        this.reportPayload = null;
        this.currentReportPayload = null;
    }

    @action
    setCurrentReportPayload(payload) {
        this.currentReportPayload = payload;
    }

    // @action
    // async applyFilter(key, value, display) {
    //     this.update_new_filters(key, value, display);
    //
    //     if (!this.currentReportPayload) return;
    //
    //     await this.getFieldReport({
    //         ...this.currentReportPayload,
    //     });
    // }
    // @action
    // getActiveSurveyResponse = async () => {
    //     try {
    //         //const response = await this.rootStore.api.post('survey/getbyidwithaudio', {"clientid": this.activeSurveyResponseId})
    //         const response = await this.rootStore.api.post("survey/getbyidwithoutaudio", {
    //             clientid: this.activeSurveyResponseId,
    //         });
    //         this.activeSurveyResponse = response.data;
    //         this.tags = response.data["alltags"];
    //         this.regions = response.data["sr"]["regions"];
    //         return response;
    //     } catch (e) {
    //         // console.log("response", e)
    //     }
    // };

    kpisFromSummary() {
        const data = this.allSurveyResponsesSummary?.by_surveyor_qa || [];

        const valid = this.get_total_surveys(data, "valid");
        const invalid = this.get_total_surveys(data, "invalid");
        const pending = this.get_total_surveys(data, "not-checked");
        const total = this.get_total_surveys(data, "total");

        const audio = this.allSurveyResponsesSummary?.by_hasaudio || [];

        const hasAudio = audio.find((x) => x.status === "has audio")?.value || 0;
        const noAudio = audio.find((x) => x.status === "no audio")?.value || 0;

        return [
            { title: "Total", value: total },
            { title: "Valid", value: valid },
            { title: "Invalid", value: invalid },
            { title: "Pending", value: pending },
            { title: "Has Audio", value: hasAudio },
            { title: "No Audio", value: noAudio },
            { title: "Surveyors", value: data.length },
        ];
    }

    @action
    getActiveSurveyResponse = async () => {
        try {
            console.log("Fetching Active Survey:", this.activeSurveyResponseId);

            const response = await this.rootStore.api.post("survey/getbyidwithoutaudio", {
                clientid: this.activeSurveyResponseId,
            });

            console.log("Active Survey Response:", response.data);

            this.activeSurveyResponse = response.data;

            // ===========================
            // ADD THIS BLOCK HERE
            // ===========================

            this.applyAudioFromDetail(this.activeSurveyResponseId, response.data);

            // ===========================
            // END
            // ===========================

            this.tags = response.data.alltags;
            this.regions = response.data.sr.regions;

            return response;
        } catch (e) {
            console.error(e);
        }
    };

    @action
    applyAudioFromDetail = (id, detail) => {
        this.allSurveyResponses = mergeAudioDetail(this.allSurveyResponses, id, detail);
    };

    hydrateAudioFlags = () => hydrateAudioFlags(this);

    @action
    update_new_filters(filterkey, filterval, display = "") {
        const filters = _.clone(this.new_filters);
        const temp = _.remove(filters, { key: filterkey });
        const tuple = {
            key: filterkey,
            val: filterval,
            display: display,
        };
        filters.push(tuple);
        this.new_filters = filters;
        console.log("filters", toJS(filters));
        return this.new_filters;
    }

    // @action
    // remove_new_filters(tuple) {
    //     const { key, val, display } = tuple;
    //     const filters = _.clone(this.new_filters);
    //     const temp = _.remove(filters, { key: key });
    //     this.new_filters = filters;
    //     return this.new_filters;
    // }

    @action
    async remove_new_filters(tuple) {
        const { key } = tuple;

        const filters = _.clone(this.new_filters);

        _.remove(filters, { key });

        this.new_filters = filters;

        if (this.currentReportPayload) {
            await this.getFieldReport({
                ...this.currentReportPayload,
            });
        }

        console.log("Remove Payload", this.currentReportPayload);
        return this.new_filters;
    }
    @action
    async reset_new_filters() {
        this.new_filters = [];

        if (this.currentReportPayload) {
            await this.getFieldReport({
                ...this.currentReportPayload,
            });
        }
        console.log("Reset Payload", this.currentReportPayload);
    }

    // @action
    // reset_new_filters() {
    //     this.new_filters = [];
    // }

    @action
    setSummary(summary: any) {
        this.allSurveyResponsesSummary = summary;
    }

    @action
    setReportPayload(payload: any) {
        this.reportPayload = payload;
    }

    @action
    setAnalyticalData(meta: any, data: any) {
        this.analytical_meta = meta || [];
        this.analytical_data = data || {};
    }
    @action
    setRegions = async (regions) => {
        this.regions = regions;
    };

    @action
    updateRegion = (region) => {
        const tmp = _.clone(this.regions);
        const index = _.findIndex(tmp, { id: region.id });
        tmp[index] = region;
        this.regions = tmp;
        return this.regions;
    };

    @action
    deleteRegion = (region) => {
        const tmp = _.clone(this.regions);
        const index = _.findIndex(tmp, { id: region.id });
        tmp.splice(index, 1);
        this.regions = tmp;
        return this.regions;
    };

    @action
    setActiveSurveyId = (id) => {
        this.activeSurveyId = id;
    };

    @action
    setSurveyListAPI = (api) => {
        this.survey_list_api = api;
    };

    @action
    setCurrentPage = (pagenum) => {
        this.currentPageTracker = pagenum;
    };

    // @action
    // getFieldReport = async (payload) => {
    //     this.loading = true;
    //     this.currentReportPayload = payload;
    //
    //     try {
    //         if (payload["surveyid"] == -1) {
    //             return;
    //         }
    //
    //         payload["filters"] = {};
    //         this.new_filters.forEach((x) => {
    //             const { key, val } = x;
    //             payload["filters"][key] = val;
    //         });
    //
    //         const response = await this.rootStore.api.post(
    //             // "/project/esfieldteamreport3",
    //             "/project/esfieldteamreport4",
    //             payload
    //         );
    //         if (response?.data) {
    //             this.allSurveyResponses = response.data["srs"] || [];
    //             this.allSurveyResponsesSummary = response.data["summary"] || {};
    //
    //             try {
    //                 this.analytical_meta = response.data["analytical_meta"];
    //                 this.analytical_data = response.data["analytical"];
    //                 this.allTags = safe_get(response.data, "alltags", []);
    //             } catch (e) {
    //                 console.error("Error extracting analytical data:", e);
    //             }
    //         }
    //
    //         return response;
    //     } catch (error) {
    //         console.error("Error fetching field report:", error);
    //         this.allSurveyResponses = [];
    //         this.allSurveyResponsesSummary = {};
    //         return null;
    //     } finally {
    //         this.loading = false;
    //     }
    // };
    @action
    setReportVersion(version: number) {
        this.reportVersion = version;
    }

    @action
    async getFieldReport(payload) {
        this.loading = true;

        this.currentReportPayload = payload;

        try {
            if (payload["surveyid"] == -1) {
                return;
            }

            payload["filters"] = {};

            this.new_filters.forEach((x) => {
                const { key, val } = x;

                payload["filters"][key] = val;
            });

            const endpoint =
                this.reportVersion === 4 ? "/project/esfieldteamreport4" : "/project/esfieldteamreport3";

            console.log("REPORT API:", endpoint, "VERSION:", this.reportVersion);

            const response = await this.rootStore.api.post(endpoint, payload);

            if (response?.data) {
                const surveyRows = response.data["srs"] || [];
                this.noAudioSampleIds = noAudioClientIds(surveyRows);
                this.allSurveyResponses = surveyRows.map(withAudioFlag);

                const summary = response.data["summary"] || {};
                this.allSurveyResponsesSummary =
                    this.new_filters?.length > 0 ? fillNullSummary(summary, this.allSurveyResponses) : summary;

                try {
                    this.analytical_meta = response.data["analytical_meta"];

                    this.analytical_data = response.data["analytical"];

                    this.allTags = safe_get(response.data, "alltags", []);
                } catch (e) {
                    console.error("Analytical error", e);
                }
            }

            return response;
        } catch (error) {
            console.error("Field report error", error);

            this.allSurveyResponses = [];
            this.noAudioSampleIds = [];

            this.allSurveyResponsesSummary = {};

            return null;
        } finally {
            this.loading = false;
        }
    }

    @action
    getFieldReportV3 = async (payload) => {
        this.reportVersion = 3;

        return await this.getFieldReport(payload);
    };

    @action
    getFieldReportV4 = async (payload) => {
        this.reportVersion = 4;

        return await this.getFieldReport(payload);
    };

    // @action
    // async applyFilter(key, value, display) {
    //     this.update_new_filters(key, value, display);
    //
    //     if (!this.currentReportPayload) return;
    //
    //     return await this.getFieldReport({
    //         ...this.currentReportPayload,
    //     });
    // }
    //
    // @action
    // async applyFilterv2(key, value, display) {
    //     this.update_new_filters(key, value, display);
    //
    //     if (!this.currentReportPayload) return;
    //
    //     return await this.getFieldReportV4({
    //         ...this.currentReportPayload,
    //     });
    // }

    @action
    async applyFilter(key, value, display) {
        this.update_new_filters(key, value, display);

        if (!this.currentReportPayload) return;

        return await this.getFieldReport({
            ...this.currentReportPayload,
        });
    }

    @action
    get_esdata = async (payload) => {
        if (payload === "") {
            return;
        }
        const response = await this.rootStore.api.post("/fs/esdata", payload);
        this.allSurveyResponses = response.data;
        return response.data;
    };

    // @action
    // setActiveSurveyResponseId = (id) => {
    //     this.activeSurveyResponseId = id;
    //     // localStorage.setItem("activeSurveyResponseId", id);
    // };

    @action
    setActiveSurveyResponseId = (id) => {
        this.activeSurveyResponseId = id;

        this.activeSurveyResponse = this.allSurveyResponses.find((x) => x.id === id) || null;
    };

    @action
    updateFilter = (filterKey, filterValue) => {
        const newFilters = _.clone(this.surveyResponseFilters);
        newFilters[filterKey] = filterValue;
        this.surveyResponseFilters = newFilters;
        return this.surveyResponseFilters;
    };

    @action
    clearAllFilters = () => {
        this.new_filters = [];
        return [];
    };

    hasKey = (keyname) => {
        if (this.allSurveyResponses.length < 1) {
            return false;
        }
        const sampleRow = toJS(this.allSurveyResponses)[0];
        const keyList = Object.keys(sampleRow);
        return keyList.includes(keyname);
    };

    hasFilters = () => {
        return Object.keys(this.surveyResponseFilters).length > 0;
    };

    @action
    updateRegionsToServer = async () => {
        const _payload = {
            clientid: this.activeSurveyResponseId,
            regions: this.regions,
        };
        const templist = _.clone(this.allSurveyResponses);
        const current = _.filter(templist, { id: this.activeSurveyResponseId })[0];
        current["hashighlights"] = this.regions.length > 0;
        current["highlight_regions"] = this.regions;
        this.allSurveyResponses = templist;
        await this.rootStore.api.post("survey/syncregions", _payload);
        if (this.survey_list_api) {
            this.survey_list_api.setPage(this.currentPageTracker);
        }
        return;
    };

    @action
    survey_qa_report = async (clientid, status, user, ts) => {
        const response = await this.rootStore.api.post(`survey/qareport`, {
            clientid,
            status,
            user,
            ts,
        });

        const templist = _.clone(this.allSurveyResponses);
        const current = _.filter(templist, { id: this.activeSurveyResponseId })[0];
        current["qa_status"] = response.data["qa_status"];
        current["qalog"] = response.data["qalog"];
        this.allSurveyResponses = templist;

        return response;
    };

    @action
    rebuild_survey_index = async (payload) => {
        return await this.rootStore.api.post("survey/rebuildindex", payload);
    };

    @action
    check_audio_availability = async (payload) => {
        return await this.rootStore.api.post("survey/recheckaudio", payload);
    };

    @action
    recheckHasAudioEs9 = async () => {
        if (this.audioRecheckLoading) return { status: null, data: null, report: null };

        this.audioRecheckLoading = true;

        try {
            const activeProjectId = Number(this.rootStore.getActiveProjectID());
            const projectid = activeProjectId > 0 ? activeProjectId : this.currentReportPayload?.projectid;
            const surveyid = Number(this.currentReportPayload?.surveyid ?? this.activeSurveyId);
            const surveyids = surveyid > 0 ? [surveyid] : [];

            const clientids = this.noAudioSampleIds || [];
            console.log("recheck_hasaudio_es9 clientids", clientids);

            const response = await this.rootStore.api.post("survey/recheck_hasaudio_es9", {
                projectid,
                surveyids,
                clientids,
                sync_missing: true,
            });

            if (response?.status !== 202) {
                return { status: response?.status, data: response?.data, report: null };
            }

            const report = this.currentReportPayload
                ? await this.getFieldReportV4({ ...this.currentReportPayload })
                : null;

            return { status: 202, data: response?.data, report };
        } finally {
            this.audioRecheckLoading = false;
        }
    };

    @action
    download_survey_data = async (payload) => {
        return await this.rootStore.api.post("moboliseher/get_data", payload);
    };

    @action
    profile_question_options = async (payload) => {
        return await this.rootStore.api.post("profile/options", payload);
    };

    @action
    set_colors = (color) => {
        const clone = _.clone(this.colors);
        clone.push(color);
        this.colors = clone;
    };

    @action
    set_loading = (loading) => {
        this.loading = loading;
    };

    @action
    set_query = (query) => {
        this.query = query;
    };

    @action
    set_search_highlights = (status) => {
        this.searchHighlights = status;
    };

    @action
    reset_active_survey = () => {
        this.activeSurveyResponseId = null;
        localStorage.setItem("activeSurveyResponseId", "");
    };

    @action
    set_active_question = (question) => {
        this.activeQuestion = question;
    };

    @action
    setShowTableSettingsModal = (status: boolean) => {
        this.showTableSettingsModal = status;
    };

    @action
    async update_voter_reg_status(payload) {
        return await this.rootStore.api.post("survey/updatesr", payload);
    }

    @action
    rebuild_summary = () => {
        //WORK IN PROGRESS
        const summary = {
            by_user: {},
            by_date: {},
            by_hour: [],
            by_lev1: [],
            by_lev2: [],
            by_qa: [],
        };
        const transformer = new ReportTransformers();
        const filtered = transformer["filter"](
            toJS(this.allSurveyResponses),
            toJS(this.surveyResponseFilters)
        );
        filtered.map((x) => {});
    };

    get_total_surveys(data, key) {
        try {
            let totalSurveys = 0;
            if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    totalSurveys += data[i][key];
                }
            }
            return totalSurveys;
        } catch (e) {
            return 0;
        }
    }
}
